import {fields} from '@/modules/configuration/contants/notaryOffices.form';
import NotaryOfficesApiService from '@/modules/configuration/services/NotaryOfficesApiService';
import {createFieldsHook} from '@/utils/createFieldsHook';
import {createGetOneHook} from '@/utils/createGetOneHook';

export const useGetOneNotaryOffices = createGetOneHook(NotaryOfficesApiService, 'id');

export const useFields = createFieldsHook('notary', fields);
